import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'clsx';
import styles from 'src/components/SlideBtn.scss';


const SlideButton = ({
  text, lightBgColor, url, linkTitle, smallerBtns
}) => (
  <div
    className={ classNames(styles['button-wrapper'],
      {
        [styles['button-wrapper--double-sides']]: smallerBtns
      }) }
    data-test="section-button-wrapper"
  >
    <a
      className={ classNames(styles['slide-button'],
        {
          [styles['slide-button--light']]: lightBgColor,
          [styles['slide-button--smaller']]: smallerBtns
        }) }
      data-test="anchor-slider-slide"
      href={ url }
      title={ linkTitle }
    >
      {text}
    </a>
  </div>
);

SlideButton.propTypes = {
  lightBgColor: PropTypes.bool.isRequired,
  linkTitle: PropTypes.string.isRequired,
  smallerBtns: PropTypes.bool.isRequired,
  text: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired
};

export default SlideButton;
